@if (organization.compactLogoLink) {
  <img [src]="organization.compactLogoLink" alt="{{ organization.name }}" />
} @else {
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#building-s"></use></svg>
}
